"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "associatePolicy", {
  enumerable: true,
  get: function get() {
    return _actions.associatePolicy;
  }
});
Object.defineProperty(exports, "associatePolicyGetSecurityQuestions", {
  enumerable: true,
  get: function get() {
    return _actions.associatePolicyGetSecurityQuestions;
  }
});
Object.defineProperty(exports, "associatePolicyPostSecurityQuestions", {
  enumerable: true,
  get: function get() {
    return _actions.associatePolicyPostSecurityQuestions;
  }
});
exports.checkPermission = void 0;
Object.defineProperty(exports, "clearAssociatePolicy", {
  enumerable: true,
  get: function get() {
    return _actions.clearAssociatePolicy;
  }
});
Object.defineProperty(exports, "fetchCoverageForms", {
  enumerable: true,
  get: function get() {
    return _actions.fetchCoverageForms;
  }
});
Object.defineProperty(exports, "fetchPolicy", {
  enumerable: true,
  get: function get() {
    return _actions.fetchPolicy;
  }
});
Object.defineProperty(exports, "fetchPolicyBilling", {
  enumerable: true,
  get: function get() {
    return _actions.fetchPolicyBilling;
  }
});
Object.defineProperty(exports, "fetchPolicyDocuments", {
  enumerable: true,
  get: function get() {
    return _actions.fetchPolicyDocuments;
  }
});
Object.defineProperty(exports, "fetchPolicyVehicleList", {
  enumerable: true,
  get: function get() {
    return _actions.fetchPolicyVehicleList;
  }
});
Object.defineProperty(exports, "fetchSafeliteDetails", {
  enumerable: true,
  get: function get() {
    return _actions.fetchSafeliteDetails;
  }
});
var _actions = require("./actions");
var _constants = require("../../util/constants");
/* OPERATIONS = REDUX THUNKS
This file defines the public interface of the Content -- what can be dispatched from components
*/

var checkPermission = exports.checkPermission = function checkPermission(permissionInt) {
  return function (dispatch, getState) {
    if (getState().policy === undefined || getState().policy.details === undefined || getState().policy.details.permissions === undefined) {
      return false;
    }
    var p = getState().policy.details.permissions;
    var perm = p.toString(2).padStart(Object.keys(_constants.Permission).length, 0).split('');
    try {
      return perm[Object.keys(_constants.Permission).length - 1 - permissionInt] === '1';
    } catch (err) {}
    return false;
  };
};